module.exports = __webpack_public_path__ + "img/workspace-onboarding/explore-team-library-692c3dd587d7f2c8f7ab4986e1f7ff5f.png";